import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { XlsExportService } from "@main/reporting.v3/api/xls-exporting.service";
import { DashboardXlsExportingSettings } from "@main/reporting.v3/dashboard/dashboard-models";

@Injectable()
export class DashboardXlsExportingService extends XlsExportService {
    readonly url = "api/reporting3/dashboard";
    readonly entityTitle = "Dashboard";

    constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
        super(http, handlersFactory);
    }

    public async getXlsExportingFile(dashboardId: string, settings: DashboardXlsExportingSettings): Promise<Blob> {
        return this.handle(this.http.post(`${this.url}/${dashboardId}/xls-export`, settings, { responseType: "blob" }));
    }

    public async generateXls(dashboardId: string, fileName: string, settings: DashboardXlsExportingSettings): Promise<void> {
        this.performDownload(fileName, await this.getXlsExportingFile(dashboardId, settings));
    }
}